import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "prefixCls", "type", "indeterminate", "disabled", "value"];
import React from 'react';
import { RadioAbstract } from '@uiw/react-radio';
import { CheckboxGroup } from './Group';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
function InternalCheckbox(props, ref) {
  var {
      className,
      prefixCls = 'w-checkbox',
      type = 'checkbox',
      indeterminate = false,
      disabled = false,
      value = ''
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [className, indeterminate && 'indeterminate'].filter(Boolean).join(' ').trim();
  return /*#__PURE__*/_jsx(RadioAbstract, _extends({
    ref: ref
  }, other, {
    type: type,
    prefixCls: prefixCls,
    disabled: disabled,
    value: value,
    className: cls
  }));
}
var Checkbox = /*#__PURE__*/React.forwardRef(InternalCheckbox);
Checkbox.Group = CheckboxGroup;
export default Checkbox;